// Phase 1.5 — v2 image set (dark-academia / institutional)
export const IMG = {
  heroHome:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/0dc95fddae6d7e3f2b42fdbe012ed1c34dbf7cc9c1d84dd6b24435c6f3138a34.png",
  libraryInterior:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/a72797af6fa90b285d5c1f3db1d7834be527d3a0fb459895a95c0e828dcf2173.png",
  storyPath:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/07f9453639cdda6732c7141fdf6cd86b6a5a74e6b9facf452a55e0051f16cc13.png",
  founder:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/07f9453639cdda6732c7141fdf6cd86b6a5a74e6b9facf452a55e0051f16cc13.png",
  tierPlatform:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/050aa9ef6716be08db6d960b125fe095f2edb1c0dd409f8ae5d4645743ae575d.png",
  tierState:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/7b3d88c59550c8e44ddb5cd0508e8dc53581941b46d53d4b1050778bb3daedbd.png",
  tierNationwide:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/0d90f0111d110de4ce10a7d89fb63c45f604916fc57b7dca66081840a3554271.png",
};

// Legacy Phase 1 set kept for archival reference. Not used by the active site.
export const LEGACY_IMG = {
  heroHome:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/da9eec1d54679004ade16c31dfb22e910be59ab926774bc8d3a32cefa2896d0e.png",
  storyPath:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/78e8ec461c871d3b85edb68ee79bd082f5738c5445609275e5830080979e64a0.png",
  founder:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/058374c5f85756b0e7d3e010791ef5d179351e4d979a7a7fd94212008f103339.png",
  tierPlatform:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/29876148840f0f0493b9aedc6845ec073eb036d5aac2b65e8e49dea22fbeef12.png",
  tierState:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/19aaebccf64919e280f91fe363c12ec552fe832f1ec44beafc204d301e594e3d.png",
  tierNationwide:
    "https://static.prod-images.emergentagent.com/jobs/9416f524-596b-4ee0-b639-65571c811c2b/images/ad3a31a8718bca6d8e5f69956d782a5071793ee277e1b9f7b3e20f94ccec3b27.png",
};

// Static descriptive metadata for the 3 tiers (matches backend TIERS dict).
export const TIER_META = {
  platform: {
    id: "platform",
    numeral: "I",
    name: "Platform",
    priceLabel: "$99 / year",
    promise: "The self-directed operating system every paying client uses.",
    image: IMG.tierPlatform,
    bullets: [
      "Portal access (school list builder, deadline tracker, document vault)",
      "One annual strategy session (45 minutes)",
      "Recommender tracker & FloridaShines integration",
      "Cornerstone guides library access",
    ],
    bestFor:
      "Self-directed students and parents who want the system in their hands and a periodic checkpoint with the firm.",
  },
  florida_transfer: {
    id: "florida_transfer",
    numeral: "II",
    name: "Florida Transfer",
    priceLabel: "from $1,500",
    promise: "Ongoing strategy for UF, UCF, FSU, USF, FIU and the broader Florida transfer system.",
    image: IMG.tierState,
    bullets: [
      "Everything in Platform",
      "Six strategy sessions a year",
      "Common Prerequisites Manual roadmap mapped to your major",
      "Essay support and recommender coaching for Florida targets",
    ],
    bestFor:
      "Students aiming for UF/UCF/FSU/USF/FIU who want a managed, deadline-driven plan from first semester through admit.",
  },
  selective_elite: {
    id: "selective_elite",
    numeral: "III",
    name: "Selective & Elite Transfer",
    priceLabel: "from $4,500",
    promise: "Ongoing strategy for top-50 nationwide, the Forbes New Ivies, and Ivy League transfer.",
    image: IMG.tierNationwide,
    bullets: [
      "Everything in Florida Transfer",
      "Full essay architecture for all schools (Common App + supplements)",
      "Dual mentor (Ivy alum + working professional in your field)",
      "AI-literacy track and weekly accountability",
    ],
    bestFor:
      "Students whose target list includes Michigan, UVA, UNC, the Ivies, or any of the Forbes 2026 New Ivies — and who understand this is a separate game with separate rules.",
  },
};

// One-time SKU shown on Pricing alongside the 3 ongoing tiers.
export const TRANSFER_AUDIT_META = {
  id: "transfer_audit",
  numeral: "•",
  name: "Transfer Audit",
  priceLabel: "$249 one-time",
  promise: "A one-time, comprehensive review of where you stand and what comes next.",
  image: IMG.libraryInterior,
  bullets: [
    "Transcript review against the Common Prerequisites Manual",
    "Target-school analysis (UF / UCF / FSU / USF / FIU or nationwide)",
    "Risk assessment with categorical readiness signals",
    "Written semester-by-semester roadmap for the rest of your AA",
    "60-minute strategy call to walk through the report",
  ],
  bestFor:
    "First-semester Valencia students through students with one semester left. Florida residents and out-of-state students considering the Florida pathway.",
};

